"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SiteContext_1 = require("../../contexts/SiteContext");
function LocationProvider({ locationId, children, }) {
    const value = react_1.useMemo(() => ({ id: { type: 'location', locationId } }), [locationId]);
    return jsx_runtime_1.jsx(SiteContext_1.SiteContext.Provider, Object.assign({ value: value }, { children: children }), void 0);
}
exports.LocationProvider = LocationProvider;
//# sourceMappingURL=index.js.map